module.exports = __webpack_public_path__ + "img/error.7e8c0d6e.svg";